import React, { useMemo } from "react";
import ServicesHero from "../components/services/ServicesHero";
import ServicesPillars from "../components/services/ServicesPillars";
import ServicesProcess from "../components/services/ServicesProcess";
import ServicesPackages from "../components/services/ServicesPackages";
import ServicesCta from "../components/services/ServicesCta";

const Services = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <ServicesHero />
      <ServicesPillars />
      <ServicesProcess />
      <ServicesPackages />
      <ServicesCta />
    </div>
  );
};

export default Services;
